import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=2cf370da&scoped=true&"
import script from "./message-center.vue?vue&type=script&lang=js&"
export * from "./message-center.vue?vue&type=script&lang=js&"
import style0 from "./message-center.vue?vue&type=style&index=0&id=2cf370da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf370da",
  null
  
)

export default component.exports